import { updateTemplate } from 'common/api/templates';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_FAILURE, SAVE_SUCCESS } from '../actionTypes';
import { templatesActions } from '../reducer';

import filterTemplates from './filterTemplates';

export default (filterData, values) => (dispatch) => {
    if (!values.id) return;

    const newValues = {
        title: values.title,
    };

    dispatch(templatesActions[SAVE]());

    updateTemplate(newValues, values.id)
        .then(() => {
            dispatch(templatesActions[SAVE_SUCCESS]());
            dispatch(filterTemplates(filterData));
            showToast();
        })
        .catch((error) =>
            dispatch(
                templatesActions[SAVE_FAILURE](error?.response?.data?.errors),
            ),
        );
};
